import React, { useMemo } from 'react'
import { Autocomplete, Box, TextField, Typography } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { normalFieldsOf } from '../model/samples'
import { MONO_SX, cellInputSx } from './ui'

// The normal sample of a tumour: a searchable list of verified FASTQ uploads (a
// normal's lanes are one entry), name suggestions first. `compact` is the table cell
// look.
const NormalSelect = ({ sample, options, onChange, compact = false }) => {
  const theme = useTheme()
  const value = useMemo(() => {
    if (!sample.normalFileId) return null
    return (
      options.find((o) => o.id === sample.normalFileId) || {
        id: sample.normalFileId,
        key: sample.normalKey || String(sample.normalFileId),
      }
    )
  }, [sample.normalFileId, sample.normalKey, options])

  return (
    <Autocomplete
      size="small"
      fullWidth
      value={value}
      options={options}
      onChange={(_e, next) => onChange({ ...normalFieldsOf(next), normalSuggested: false })}
      getOptionLabel={(o) => o?.key || ''}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      noOptionsText="No verified FASTQ pair matches"
      renderOption={(props, o) => (
        <Box component="li" {...props} key={o.id} sx={{ gap: 1, alignItems: 'baseline' }}>
          <Typography component="span" sx={{ ...MONO_SX }}>
            {o.key}
          </Typography>
          {o.fileIds?.length > 1 && (
            <Typography component="span" sx={{ fontSize: 12.5, color: 'text.secondary' }}>
              {o.fileIds.length} lanes
            </Typography>
          )}
          {o.suggested && (
            <Typography component="span" sx={{ fontSize: 12.5, color: 'text.secondary' }}>
              Suggested
            </Typography>
          )}
        </Box>
      )}
      renderInput={(params) =>
        compact ? (
          <TextField
            {...params}
            variant="standard"
            placeholder="Choose normal"
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            inputProps={{ ...params.inputProps, 'aria-label': `Normal sample of ${sample.key}` }}
            sx={{
              '& .MuiInputBase-root': { ...cellInputSx(theme), pr: '24px !important', py: '0 !important' },
              '& input': { ...MONO_SX, fontSize: 13 },
            }}
          />
        ) : (
          <TextField {...params} placeholder="Choose normal" sx={{ '& input': { ...MONO_SX, fontSize: 14 } }} />
        )
      }
    />
  )
}

export default NormalSelect
